<template>
  <div class="table-header-group">
    <div class="table-row">
      <div class="table-cell" v-for="(day, index) in weekDays" :key="index">
        <span>{{ day }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { dayjs } from "@/utils/helpers";
import DateConstants from "@/components/VCalendar/DateConstants.js";
export default {
  name: "DateTHead",
  props: {
    value: {
      type: Object,
      default: () => dayjs()
    }
  },
  computed: {
    weekDays() {
      let weekDays = [];
      let localeData = this.value.localeData();
      const firstDayOfWeek = localeData.firstDayOfWeek();
      const now = dayjs();
      const veryShortWeekdays = [];
      for (
        let dateColIndex = 0;
        dateColIndex < DateConstants.DATE_COL_COUNT;
        dateColIndex++
      ) {
        const index =
          (firstDayOfWeek + dateColIndex) % DateConstants.DATE_COL_COUNT;
        now.day(index);
        console.log(now.day());
        veryShortWeekdays[dateColIndex] = localeData.weekdaysMin(
          now.day(index)
        );
        // console.log(localeData.weekdaysMin(now), now.day(index).day())
        weekDays[dateColIndex] = localeData.weekdaysShort(now.day(index));
      }

      return veryShortWeekdays;
    }
  }
};
</script>
<style lang="">

</style>
